// extracted by mini-css-extract-plugin
module.exports = {"serverUri":"style-module_serverUri__1SSdtiwCjSoSGeLg11hUhX","filterBoxStandardWidth":"style-module_filterBoxStandardWidth__1-dbx_nEVS48_fC4x1BeAm"};